import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createDetergentHistory } from '@/apis/detergentHistories'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateDetergentHistoryRequest } from '@/types/apis/detergentHistories/CreateDetergentHistoryRequest'
import { CreateDetergentHistoryResponse } from '@/types/apis/detergentHistories/CreateDetergentHistoryResponse'

export const useCreateDetergentHistory = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateDetergentHistoryResponse>()

  const create = useCallback(
    async (request: CreateDetergentHistoryRequest) => {
      try {
        setLoading(true)
        const res = await createDetergentHistory(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        const path = routes.detergentHistories.path.replace(':id', request.detergentId.toString())
        navigate(path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createDetergentHistory: create,
    response,
  }
}
